module.exports = __webpack_public_path__ + "static/img/log_2.f2ef746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/log_2.jpg
// module id = 6TRX
// module chunks = 1